// Comprehensive city to timezone mapping
// This database includes major cities, capitals, and important business centers worldwide

export const cityTimezoneMap = {
  // ========== NORTH AMERICA ==========
  
  // United States - Eastern Time
  'New York': 'America/New_York',
  'Boston': 'America/New_York',
  'Philadelphia': 'America/New_York',
  'Washington': 'America/New_York',
  'Washington DC': 'America/New_York',
  'Miami': 'America/New_York',
  'Atlanta': 'America/New_York',
  'Detroit': 'America/New_York',
  'Charlotte': 'America/New_York',
  'Pittsburgh': 'America/New_York',
  'Orlando': 'America/New_York',
  'Tampa': 'America/New_York',
  'Baltimore': 'America/New_York',
  'Richmond': 'America/New_York',
  'Raleigh': 'America/New_York',
  'Buffalo': 'America/New_York',
  'Rochester': 'America/New_York',
  'Cleveland': 'America/New_York',
  'Cincinnati': 'America/New_York',
  'Columbus': 'America/New_York',
  'Indianapolis': 'America/New_York',
  'Jacksonville': 'America/New_York',
  
  // United States - Central Time
  'Chicago': 'America/Chicago',
  'Dallas': 'America/Chicago',
  'Houston': 'America/Chicago',
  'San Antonio': 'America/Chicago',
  'Austin': 'America/Chicago',
  'Nashville': 'America/Chicago',
  'Memphis': 'America/Chicago',
  'New Orleans': 'America/Chicago',
  'Oklahoma City': 'America/Chicago',
  'Kansas City': 'America/Chicago',
  'Minneapolis': 'America/Chicago',
  'St Louis': 'America/Chicago',
  'Milwaukee': 'America/Chicago',
  'Madison': 'America/Chicago',
  'Omaha': 'America/Chicago',
  'Des Moines': 'America/Chicago',
  'Wichita': 'America/Chicago',
  'Little Rock': 'America/Chicago',
  'Birmingham': 'America/Chicago',
  'Jackson': 'America/Chicago',
  
  // United States - Mountain Time
  'Denver': 'America/Denver',
  'Salt Lake City': 'America/Denver',
  'Albuquerque': 'America/Denver',
  'El Paso': 'America/Denver',
  'Boise': 'America/Denver',
  'Colorado Springs': 'America/Denver',
  'Billings': 'America/Denver',
  'Cheyenne': 'America/Denver',
  
  // United States - Mountain Time (Arizona - no DST)
  'Phoenix': 'America/Phoenix',
  'Tucson': 'America/Phoenix',
  'Mesa': 'America/Phoenix',
  'Scottsdale': 'America/Phoenix',
  
  // United States - Pacific Time
  'Los Angeles': 'America/Los_Angeles',
  'San Francisco': 'America/Los_Angeles',
  'San Diego': 'America/Los_Angeles',
  'San Jose': 'America/Los_Angeles',
  'Seattle': 'America/Los_Angeles',
  'Portland': 'America/Los_Angeles',
  'Sacramento': 'America/Los_Angeles',
  'Las Vegas': 'America/Los_Angeles',
  'Fresno': 'America/Los_Angeles',
  'Oakland': 'America/Los_Angeles',
  'Reno': 'America/Los_Angeles',
  'Spokane': 'America/Los_Angeles',
  'Tacoma': 'America/Los_Angeles',
  'Eugene': 'America/Los_Angeles',
  
  // United States - Alaska
  'Anchorage': 'America/Anchorage',
  'Juneau': 'America/Juneau',
  'Fairbanks': 'America/Anchorage',
  
  // United States - Hawaii
  'Honolulu': 'Pacific/Honolulu',
  
  // Canada
  'Toronto': 'America/Toronto',
  'Montreal': 'America/Toronto',
  'Ottawa': 'America/Toronto',
  'Vancouver': 'America/Vancouver',
  'Calgary': 'America/Edmonton',
  'Edmonton': 'America/Edmonton',
  'Winnipeg': 'America/Winnipeg',
  'Quebec City': 'America/Toronto',
  'Hamilton': 'America/Toronto',
  'Kitchener': 'America/Toronto',
  'London': 'America/Toronto',
  'Victoria': 'America/Vancouver',
  'Halifax': 'America/Halifax',
  'Saskatoon': 'America/Regina',
  'Regina': 'America/Regina',
  'St Johns': 'America/St_Johns',
  
  // Mexico
  'Mexico City': 'America/Mexico_City',
  'Guadalajara': 'America/Mexico_City',
  'Monterrey': 'America/Monterrey',
  'Cancun': 'America/Cancun',
  'Tijuana': 'America/Tijuana',
  'Puebla': 'America/Mexico_City',
  'Merida': 'America/Merida',
  
  // ========== CENTRAL AMERICA & CARIBBEAN ==========
  'Guatemala City': 'America/Guatemala',
  'San Salvador': 'America/El_Salvador',
  'Tegucigalpa': 'America/Tegucigalpa',
  'Managua': 'America/Managua',
  'San Jose': 'America/Costa_Rica',
  'Panama City': 'America/Panama',
  'Havana': 'America/Havana',
  'Kingston': 'America/Jamaica',
  'Port-au-Prince': 'America/Port-au-Prince',
  'Santo Domingo': 'America/Santo_Domingo',
  'San Juan': 'America/Puerto_Rico',
  
  // ========== SOUTH AMERICA ==========
  'São Paulo': 'America/Sao_Paulo',
  'Rio de Janeiro': 'America/Sao_Paulo',
  'Brasília': 'America/Sao_Paulo',
  'Brasilia': 'America/Sao_Paulo',
  'Salvador': 'America/Bahia',
  'Fortaleza': 'America/Fortaleza',
  'Belo Horizonte': 'America/Sao_Paulo',
  'Manaus': 'America/Manaus',
  'Recife': 'America/Recife',
  'Buenos Aires': 'America/Argentina/Buenos_Aires',
  'Córdoba': 'America/Argentina/Cordoba',
  'Rosario': 'America/Argentina/Cordoba',
  'Mendoza': 'America/Argentina/Mendoza',
  'Santiago': 'America/Santiago',
  'Valparaíso': 'America/Santiago',
  'Lima': 'America/Lima',
  'Bogotá': 'America/Bogota',
  'Bogota': 'America/Bogota',
  'Medellín': 'America/Bogota',
  'Cali': 'America/Bogota',
  'Caracas': 'America/Caracas',
  'Quito': 'America/Guayaquil',
  'Guayaquil': 'America/Guayaquil',
  'La Paz': 'America/La_Paz',
  'Santa Cruz': 'America/La_Paz',
  'Montevideo': 'America/Montevideo',
  'Asunción': 'America/Asuncion',
  'Asuncion': 'America/Asuncion',
  
  // ========== EUROPE ==========
  
  // United Kingdom & Ireland
  'London': 'Europe/London',
  'Manchester': 'Europe/London',
  'Birmingham': 'Europe/London',
  'Leeds': 'Europe/London',
  'Glasgow': 'Europe/London',
  'Edinburgh': 'Europe/London',
  'Liverpool': 'Europe/London',
  'Bristol': 'Europe/London',
  'Cardiff': 'Europe/London',
  'Belfast': 'Europe/Belfast',
  'Dublin': 'Europe/Dublin',
  'Cork': 'Europe/Dublin',
  
  // Western Europe
  'Paris': 'Europe/Paris',
  'Marseille': 'Europe/Paris',
  'Lyon': 'Europe/Paris',
  'Toulouse': 'Europe/Paris',
  'Nice': 'Europe/Paris',
  'Nantes': 'Europe/Paris',
  'Strasbourg': 'Europe/Paris',
  'Bordeaux': 'Europe/Paris',
  'Berlin': 'Europe/Berlin',
  'Hamburg': 'Europe/Berlin',
  'Munich': 'Europe/Berlin',
  'Cologne': 'Europe/Berlin',
  'Frankfurt': 'Europe/Berlin',
  'Stuttgart': 'Europe/Berlin',
  'Düsseldorf': 'Europe/Berlin',
  'Dusseldorf': 'Europe/Berlin',
  'Dortmund': 'Europe/Berlin',
  'Amsterdam': 'Europe/Amsterdam',
  'Rotterdam': 'Europe/Amsterdam',
  'The Hague': 'Europe/Amsterdam',
  'Utrecht': 'Europe/Amsterdam',
  'Brussels': 'Europe/Brussels',
  'Antwerp': 'Europe/Brussels',
  'Ghent': 'Europe/Brussels',
  'Luxembourg': 'Europe/Luxembourg',
  
  // Southern Europe
  'Madrid': 'Europe/Madrid',
  'Barcelona': 'Europe/Madrid',
  'Valencia': 'Europe/Madrid',
  'Seville': 'Europe/Madrid',
  'Málaga': 'Europe/Madrid',
  'Malaga': 'Europe/Madrid',
  'Bilbao': 'Europe/Madrid',
  'Lisbon': 'Europe/Lisbon',
  'Porto': 'Europe/Lisbon',
  'Rome': 'Europe/Rome',
  'Milan': 'Europe/Rome',
  'Naples': 'Europe/Rome',
  'Turin': 'Europe/Rome',
  'Florence': 'Europe/Rome',
  'Venice': 'Europe/Rome',
  'Bologna': 'Europe/Rome',
  'Athens': 'Europe/Athens',
  'Thessaloniki': 'Europe/Athens',
  
  // Switzerland & Austria
  'Zurich': 'Europe/Zurich',
  'Geneva': 'Europe/Zurich',
  'Basel': 'Europe/Zurich',
  'Bern': 'Europe/Zurich',
  'Lausanne': 'Europe/Zurich',
  'Vienna': 'Europe/Vienna',
  'Graz': 'Europe/Vienna',
  'Salzburg': 'Europe/Vienna',
  'Innsbruck': 'Europe/Vienna',
  
  // Nordic Countries
  'Stockholm': 'Europe/Stockholm',
  'Gothenburg': 'Europe/Stockholm',
  'Malmö': 'Europe/Stockholm',
  'Malmo': 'Europe/Stockholm',
  'Copenhagen': 'Europe/Copenhagen',
  'Aarhus': 'Europe/Copenhagen',
  'Oslo': 'Europe/Oslo',
  'Bergen': 'Europe/Oslo',
  'Helsinki': 'Europe/Helsinki',
  'Espoo': 'Europe/Helsinki',
  'Reykjavik': 'Atlantic/Reykjavik',
  
  // Eastern Europe
  'Warsaw': 'Europe/Warsaw',
  'Kraków': 'Europe/Warsaw',
  'Krakow': 'Europe/Warsaw',
  'Prague': 'Europe/Prague',
  'Brno': 'Europe/Prague',
  'Budapest': 'Europe/Budapest',
  'Bucharest': 'Europe/Bucharest',
  'Sofia': 'Europe/Sofia',
  'Belgrade': 'Europe/Belgrade',
  'Zagreb': 'Europe/Zagreb',
  'Ljubljana': 'Europe/Ljubljana',
  'Bratislava': 'Europe/Bratislava',
  'Tallinn': 'Europe/Tallinn',
  'Riga': 'Europe/Riga',
  'Vilnius': 'Europe/Vilnius',
  'Kyiv': 'Europe/Kiev',
  'Kiev': 'Europe/Kiev',
  'Minsk': 'Europe/Minsk',
  'Moscow': 'Europe/Moscow',
  'St Petersburg': 'Europe/Moscow',
  'Novosibirsk': 'Asia/Novosibirsk',
  'Yekaterinburg': 'Asia/Yekaterinburg',
  'Vladivostok': 'Asia/Vladivostok',
  
  // ========== MIDDLE EAST ==========
  'Istanbul': 'Europe/Istanbul',
  'Ankara': 'Europe/Istanbul',
  'Izmir': 'Europe/Istanbul',
  'Dubai': 'Asia/Dubai',
  'Abu Dhabi': 'Asia/Dubai',
  'Sharjah': 'Asia/Dubai',
  'Doha': 'Asia/Qatar',
  'Riyadh': 'Asia/Riyadh',
  'Jeddah': 'Asia/Riyadh',
  'Mecca': 'Asia/Riyadh',
  'Medina': 'Asia/Riyadh',
  'Kuwait City': 'Asia/Kuwait',
  'Manama': 'Asia/Bahrain',
  'Muscat': 'Asia/Muscat',
  'Amman': 'Asia/Amman',
  'Beirut': 'Asia/Beirut',
  'Damascus': 'Asia/Damascus',
  'Baghdad': 'Asia/Baghdad',
  'Tehran': 'Asia/Tehran',
  'Tel Aviv': 'Asia/Jerusalem',
  'Jerusalem': 'Asia/Jerusalem',
  'Haifa': 'Asia/Jerusalem',
  
  // ========== AFRICA ==========
  'Cairo': 'Africa/Cairo',
  'Alexandria': 'Africa/Cairo',
  'Lagos': 'Africa/Lagos',
  'Kano': 'Africa/Lagos',
  'Ibadan': 'Africa/Lagos',
  'Johannesburg': 'Africa/Johannesburg',
  'Cape Town': 'Africa/Johannesburg',
  'Durban': 'Africa/Johannesburg',
  'Pretoria': 'Africa/Johannesburg',
  'Nairobi': 'Africa/Nairobi',
  'Mombasa': 'Africa/Nairobi',
  'Accra': 'Africa/Accra',
  'Addis Ababa': 'Africa/Addis_Ababa',
  'Dar es Salaam': 'Africa/Dar_es_Salaam',
  'Casablanca': 'Africa/Casablanca',
  'Rabat': 'Africa/Casablanca',
  'Algiers': 'Africa/Algiers',
  'Tunis': 'Africa/Tunis',
  'Tripoli': 'Africa/Tripoli',
  'Khartoum': 'Africa/Khartoum',
  'Kinshasa': 'Africa/Kinshasa',
  'Luanda': 'Africa/Luanda',
  'Kampala': 'Africa/Kampala',
  'Harare': 'Africa/Harare',
  'Lusaka': 'Africa/Lusaka',
  'Maputo': 'Africa/Maputo',
  'Dakar': 'Africa/Dakar',
  'Abidjan': 'Africa/Abidjan',
  
  // ========== ASIA ==========
  
  // East Asia
  'Tokyo': 'Asia/Tokyo',
  'Osaka': 'Asia/Tokyo',
  'Yokohama': 'Asia/Tokyo',
  'Nagoya': 'Asia/Tokyo',
  'Sapporo': 'Asia/Tokyo',
  'Fukuoka': 'Asia/Tokyo',
  'Kyoto': 'Asia/Tokyo',
  'Beijing': 'Asia/Shanghai',
  'Shanghai': 'Asia/Shanghai',
  'Guangzhou': 'Asia/Shanghai',
  'Shenzhen': 'Asia/Shanghai',
  'Chengdu': 'Asia/Shanghai',
  'Chongqing': 'Asia/Shanghai',
  'Tianjin': 'Asia/Shanghai',
  'Wuhan': 'Asia/Shanghai',
  'Hangzhou': 'Asia/Shanghai',
  'Nanjing': 'Asia/Shanghai',
  'Xi\'an': 'Asia/Shanghai',
  'Seoul': 'Asia/Seoul',
  'Busan': 'Asia/Seoul',
  'Incheon': 'Asia/Seoul',
  'Taipei': 'Asia/Taipei',
  'Kaohsiung': 'Asia/Taipei',
  'Hong Kong': 'Asia/Hong_Kong',
  'Macau': 'Asia/Macau',
  
  // Southeast Asia
  'Singapore': 'Asia/Singapore',
  'Bangkok': 'Asia/Bangkok',
  'Chiang Mai': 'Asia/Bangkok',
  'Phuket': 'Asia/Bangkok',
  'Kuala Lumpur': 'Asia/Kuala_Lumpur',
  'George Town': 'Asia/Kuala_Lumpur',
  'Johor Bahru': 'Asia/Kuala_Lumpur',
  'Jakarta': 'Asia/Jakarta',
  'Surabaya': 'Asia/Jakarta',
  'Bandung': 'Asia/Jakarta',
  'Medan': 'Asia/Jakarta',
  'Bali': 'Asia/Makassar',
  'Manila': 'Asia/Manila',
  'Quezon City': 'Asia/Manila',
  'Davao': 'Asia/Manila',
  'Cebu': 'Asia/Manila',
  'Hanoi': 'Asia/Ho_Chi_Minh',
  'Ho Chi Minh City': 'Asia/Ho_Chi_Minh',
  'Ho Chi Minh': 'Asia/Ho_Chi_Minh',
  'Saigon': 'Asia/Ho_Chi_Minh',
  'Da Nang': 'Asia/Ho_Chi_Minh',
  'Phnom Penh': 'Asia/Phnom_Penh',
  'Vientiane': 'Asia/Vientiane',
  'Yangon': 'Asia/Yangon',
  'Rangoon': 'Asia/Yangon',
  
  // South Asia
  'Mumbai': 'Asia/Kolkata',
  'Delhi': 'Asia/Kolkata',
  'New Delhi': 'Asia/Kolkata',
  'Bangalore': 'Asia/Kolkata',
  'Bengaluru': 'Asia/Kolkata',
  'Hyderabad': 'Asia/Kolkata',
  'Chennai': 'Asia/Kolkata',
  'Kolkata': 'Asia/Kolkata',
  'Calcutta': 'Asia/Kolkata',
  'Pune': 'Asia/Kolkata',
  'Ahmedabad': 'Asia/Kolkata',
  'Jaipur': 'Asia/Kolkata',
  'Surat': 'Asia/Kolkata',
  'Lucknow': 'Asia/Kolkata',
  'Kanpur': 'Asia/Kolkata',
  'Nagpur': 'Asia/Kolkata',
  'Karachi': 'Asia/Karachi',
  'Lahore': 'Asia/Karachi',
  'Islamabad': 'Asia/Karachi',
  'Dhaka': 'Asia/Dhaka',
  'Chittagong': 'Asia/Dhaka',
  'Colombo': 'Asia/Colombo',
  'Kathmandu': 'Asia/Kathmandu',
  
  // Central Asia
  'Almaty': 'Asia/Almaty',
  'Nur-Sultan': 'Asia/Almaty',
  'Astana': 'Asia/Almaty',
  'Tashkent': 'Asia/Tashkent',
  'Bishkek': 'Asia/Bishkek',
  'Dushanbe': 'Asia/Dushanbe',
  'Ashgabat': 'Asia/Ashgabat',
  
  // ========== OCEANIA ==========
  
  // Australia
  'Sydney': 'Australia/Sydney',
  'Melbourne': 'Australia/Melbourne',
  'Brisbane': 'Australia/Brisbane',
  'Perth': 'Australia/Perth',
  'Adelaide': 'Australia/Adelaide',
  'Gold Coast': 'Australia/Brisbane',
  'Canberra': 'Australia/Sydney',
  'Newcastle': 'Australia/Sydney',
  'Wollongong': 'Australia/Sydney',
  'Geelong': 'Australia/Melbourne',
  'Hobart': 'Australia/Hobart',
  'Darwin': 'Australia/Darwin',
  'Cairns': 'Australia/Brisbane',
  'Toowoomba': 'Australia/Brisbane',
  'Townsville': 'Australia/Brisbane',
  
  // New Zealand
  'Auckland': 'Pacific/Auckland',
  'Wellington': 'Pacific/Auckland',
  'Christchurch': 'Pacific/Auckland',
  'Hamilton': 'Pacific/Auckland',
  'Tauranga': 'Pacific/Auckland',
  'Dunedin': 'Pacific/Auckland',
  'Queenstown': 'Pacific/Auckland',
  
  // Pacific Islands
  'Suva': 'Pacific/Fiji',
  'Port Moresby': 'Pacific/Port_Moresby',
  'Noumea': 'Pacific/Noumea',
  'Papeete': 'Pacific/Tahiti',
  'Apia': 'Pacific/Apia',
  'Nuku\'alofa': 'Pacific/Tongatapu',
  'Port Vila': 'Pacific/Efate',
  'Honiara': 'Pacific/Guadalcanal',
  'Guam': 'Pacific/Guam',
  'Saipan': 'Pacific/Saipan',
};

export default cityTimezoneMap;
